import './global.css'
import '#/platform/markBundleStartTime'
import '#/platform/polyfills'

import {registerRootComponent} from 'expo'

import App from '#/App'

registerRootComponent(App)
